import { Link } from "react-router-dom";
import { Car, Bike, CarTaxiFront, BadgeCheck, Clock, MapPin, Star } from "lucide-react";

const VEHICLE_ICONS = { car: Car, bike: Bike, auto: CarTaxiFront, cab: CarTaxiFront };

export const RideCard = ({ ride }) => {
  const Icon = VEHICLE_ICONS[ride.vehicle_type] || Car;
  return (
    <Link to={`/rides/${ride.id}`} data-testid={`ride-card-${ride.id}`}
      className="t-card block p-5 hover:-translate-y-1 transition-transform duration-200">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 text-sm font-bold">
            <MapPin className="w-4 h-4 text-primary shrink-0" />
            <span className="truncate">{ride.from_location}</span>
            <span className="text-muted-foreground">→</span>
            <span className="truncate">{ride.to_location}</span>
          </div>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-2 text-xs text-muted-foreground">
            <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {ride.date} · {ride.departure_time}</span>
            <span className="flex items-center gap-1"><Icon className="w-3 h-3" /> {ride.vehicle_type}</span>
            <span>{ride.seats_left} seat{ride.seats_left !== 1 ? "s" : ""} left</span>
            {typeof ride.pickup_distance_km === "number" && (
              <span data-testid="pickup-distance">{ride.pickup_distance_km} km from your pickup</span>
            )}
            <span className="font-bold text-foreground">₹{ride.contribution}/seat</span>
          </div>
          <div className="flex items-center gap-2 mt-3">
            <div className="w-7 h-7 rounded-full bg-secondary/30 flex items-center justify-center text-xs font-bold">
              {ride.driver?.name?.[0] || "?"}
            </div>
            <span className="text-sm font-semibold">{ride.driver?.name}</span>
            {ride.driver?.verification_status === "verified" && (
              <BadgeCheck className="w-4 h-4 text-primary" />
            )}
            {ride.driver?.completed_rides > 0 && (
              <span className="text-xs text-muted-foreground">{ride.driver.completed_rides} rides</span>
            )}
            {typeof ride.driver?.rating === "number" && (
              <span data-testid="driver-rating" className="flex items-center gap-0.5 text-xs font-bold">
                <Star className="w-3 h-3 fill-[#FFB800] text-[#FFB800]" /> {ride.driver.rating}
              </span>
            )}
          </div>
        </div>
        {typeof ride.match_score === "number" && (
          <div data-testid="match-score" className="shrink-0 w-14 h-14 rounded-full border-4 border-primary/20 flex items-center justify-center">
            <span className="font-display font-black text-sm text-primary">{ride.match_score}%</span>
          </div>
        )}
      </div>
    </Link>
  );
};
